import createUrlPattern from "./createUrlPattern"
import checkUrlAgainstPattern from "./checkUrlAgainstPattern"
import getIndexOfThreads from "./getIndexOfThreads"
import getThreadById from "./fetchApiHelpers/getThreadById"

interface Thread {
	// TODO
	_id: string
	location: {
		host: string
		path: string
		selector: string
	}
}

interface Result {
	enableJam: boolean
	detachedThreadToDisplay: Thread | false
	typeOfDetachedThread: "resolved" | "detached" | false
	indexOfThreadIfOnThisPage: number | false
	elementThreadIsAttachedTo: Element | false
}

export default async function handleQueryStringForDirectLinksToComments(
	JAM_ID: string,
	threads: Thread[],
): Promise<Result> {
	let returnObj: Result = {
		enableJam: false,
		detachedThreadToDisplay: false,
		typeOfDetachedThread: false,
		indexOfThreadIfOnThisPage: false,
		elementThreadIsAttachedTo: false,
	}
	// we use query params to link direct to an open comment/thread so this checks if there is a query param
	if (window.location.search) {
		// get all the query strings in format [{ key: "name", value: "value" }, etc.]
		const qs = window.location.search
			.split("?")[1]
			.split("&")
			.map((str) => {
				return { key: str.split("=")[0], value: str.split("=")[1] }
			})

		// check if any of the query strings are named jam and value is berrygood, if so, enable jam
		const shouldWeJam = qs.findIndex(
			(e) => e.key === "jam" && e.value === "berrygood",
		)
		if (shouldWeJam) returnObj.enableJam = true

		// check if any of the query strings are named jamThread, if so, enable jam and go to that thread
		let threadIdToOpenQs = qs.find((e) => e.key === "jam-to-sample")
		let threadIdToOpen = threadIdToOpenQs ? threadIdToOpenQs.value : false

		if (threadIdToOpen) {
			returnObj.enableJam = true

			// check threads to see if it's there
			const index = getIndexOfThreads(threadIdToOpen, threads)

			if (index === -1) {
				// not in threads, go check to see if it's resolved
				const thread = await getThreadById(JAM_ID, threadIdToOpen)
				if (thread) {
					returnObj.detachedThreadToDisplay = thread
					returnObj.typeOfDetachedThread = "resolved"
				}
			} else {
				const thread = threads[index]

				// is this the right page to display jam on
				const { host, pathPatternArray } = createUrlPattern(
					window.location.host,
					window.location.pathname,
				)
				const correctPageToDisplayThreadOn = checkUrlAgainstPattern(
					{ host, pathPatternArray },
					{
						host: thread.location.host,
						pathPatternArray: JSON.parse(thread.location.path),
					},
				)
				if (correctPageToDisplayThreadOn) {
					// is the selector currently on the page?
					const elem = document.querySelector(thread.location.selector)
					if (elem) {
						//let's open the thread then lets go there
						returnObj.indexOfThreadIfOnThisPage = index
						returnObj.elementThreadIsAttachedTo = elem
					} else {
						// element not currently on the page, lets display it anyway with a little note
						returnObj.detachedThreadToDisplay = thread
						returnObj.typeOfDetachedThread = "detached"
					}
				} else {
					// this jam is not on this page let's redirect there
					// this redirects forever indefinitely TODO
					window.location.replace(
						`http://${thread.location.host}?jam-to-sample=${threadIdToOpen}`,
					)
				}
			}
		}
	}
	return returnObj
}
